$component-class: 'sn-navbar-type-2';

.#{$component-class} {
  position: relative;
  width: 100%;
  z-index: 100;
  background-color: var(--color-neutral-white);

  &__container {
    display: flex;
    align-items: center;

    @include container;

    padding-top: calc(var(--spacing-md) - 2px);
    padding-bottom: calc(var(--spacing-md) - 2px);
    max-width: 1312px;

    @include desktop {
      padding-top: 0;
      padding-bottom: 0;
    }
  }

  &__logo-column {
    display: flex;
    align-items: center;
    padding: 0;

    @include above($breakpoint-desktop-md) {
      padding: var(--spacing-md) 0;
    }
  }

  &__logo-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;

    svg {
      display: block;
    }
  }
}
